'use client';

import cn from 'classnames';
import type { ComponentProps } from 'react';

import styles from './SwdFormGroup.module.scss';

export type SwdFormGroupProps = ComponentProps<'div'> & {
  /** Horizontal layout (replaces MUI FormGroup `row`). */
  row?: boolean;
};

export function SwdFormGroup({ className, row, ...props }: SwdFormGroupProps) {
  return (
    <div
      className={cn(className, row && styles.row)}
      data-swd-form-group=""
      data-swd-row={row ? 'true' : undefined}
      role="group"
      {...props}
    />
  );
}
